import { AxiosResponse }  from 'axios'

export const isSuccess = (response: AxiosResponse): boolean => {
    return response.statusText === "OK" || response.status === 200;
}